export class ValuacionDetalle {
    public idValuacionDetalle: number;
    public idValuacion: number;
    public tipo: string;
    public cantidad: number;
    public descripcion: string;
    public observaciones: string;
    public precioUnitario: number;
    public orden: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/valuacionDetalle.ts